module.exports = __webpack_public_path__ + "img/soulpay.62aa70c8.png";